import React from "react";
import moment from "moment";
import { getData, getDateString } from "../utils";

class CalendarSummary extends React.Component {
  state = {
    today_date: {
      month: "",
      date: "",
      day: "",
    },
    upcoming_events: [],
    today_events: [],
  };

  async componentDidMount() {
    const today = moment().toDate();

    //For some strange reason, setting the end time anywhere greater than 10pm gets tomorrow's events
    // let endDayString = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate() + 'T22:00:00.000Z';

    const data = (
      await getData(
        [],
        {},
        {
          showDeleted: false,
          timeMin: getDateString(today),
          timeMax: getDateString(today, false, true),
        }
      )
    ).data;

    this.setState({
      today_date: {
        month:
          today.getFullYear() +
          " " +
          today.toLocaleDateString(undefined, { month: "long" }),
        date: today.getDate(),
        day: today.toLocaleDateString(undefined, { weekday: "long" }),
      },
      today_events: data,
    });
  }

  render() {
    return (
      <div className="currentDateEventsContainer">
        <div className="monthContainer">
          <span>{this.state.today_date.month}</span>
        </div>
        <div className="dayContainer">
          <span className="date">{this.state.today_date.date}</span>
          <span className="day">{this.state.today_date.day}</span>
          <span className="eventCount">
            {this.state.today_events.length > 0
              ? this.state.today_events.length
              : "No"}{" "}
            Event{this.state.today_events.length === 1 ? "" : "s"}{" "}
            {this.state.today_events.length === 0 ? "Today" : ""}
          </span>
        </div>
        <div className="eventList">
          {this.state.today_events.map(function (item, i) {
            return <p className="eventListEvent">{item.summary}</p>;
          })}
        </div>
      </div>
    );
  }
}

export default CalendarSummary;

